const formatter = new Intl.DateTimeFormat('en-US', { dateStyle: 'long' });
const shortMonthFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});

const MINUTE_IN_SECONDS = 60;
const HOUR_IN_SECONDS = 60 * 60;

export function formatDate(date: Date, format: 'default' | 'short' = 'default') {
  if (format === 'short') return shortMonthFormatter.format(date);
  return formatter.format(date);
}

export function relativeDate(date: Date, format: 'default' | 'short' = 'default') {
  const timestamp = date.getTime() / 1000;
  const secondsAgo = Math.floor(Date.now() / 1000) - timestamp;

  if (secondsAgo < 30) return 'Just now';

  const minutesAgo = Math.round(secondsAgo / MINUTE_IN_SECONDS);
  const hoursAgo = Math.round(secondsAgo / HOUR_IN_SECONDS);

  if (minutesAgo < 60) {
    return minutesAgo === 1 ? '1 minute ago' : `${minutesAgo} minutes ago`;
  }

  if (hoursAgo < 6) {
    return hoursAgo === 1 ? '1 hour ago' : `${hoursAgo} hours ago`;
  }

  return formatDate(date, format);
}

export function readableDuration(totalSeconds, spacer = ' ') {
  const hours = Math.floor(totalSeconds / 3600);
  if (hours) {
    const hoursString = hours === 1 ? `1${spacer}hr` : `${hours}${spacer}hrs`;
    const minutes = Math.round(totalSeconds / 60) % 60;
    if (minutes) {
      return `${hoursString} ${minutes}${spacer}min`;
    }
    return hoursString;
  }

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.round(totalSeconds % 60);
  if (minutes) {
    if (minutes <= 2 && seconds) {
      return `${minutes}${spacer}min ${seconds}${spacer}s`;
    } else {
      return `${minutes}${spacer}min`;
    }
  }

  return `${seconds}${spacer}s`;
}
